// Core P0 pages — homepage, Mission Ještěd a hlavní landing pages.
export const CORE_PAGES = {
  home: {
    path: "/",
    type: "home",
    seo: {
      title: "Extreme Teambuilding | Mission Ještěd & Warehouse Liberec",
      description: "Netradiční firemní teambuilding na Ještědu s ubytováním a soukromou party ve Warehouse Liberec. Mission Ještěd pro týmy 20–50 lidí.",
      schema: ["Organization", "WebSite", "WebPage"],
    },
    h1: "VAŠI LIDÉ NEBUDOU VĚDĚT, CO JE ČEKÁ.",
    breadcrumbs: [{ label: "Úvod", href: "/" }],
    blocks: [
      {
        t: "hero",
        overline: "EXTREME TEAMBUILDING BY WAREHOUSE LIBEREC",
        title: "VAŠI LIDÉ NEBUDOU VĚDĚT, CO JE ČEKÁ.",
        sub: "Jednoho rána nastoupí do auta. O chvíli později dostanou mapu, několik instrukcí a jediný úkol: dostat celý tým na Ještěd.",
        support: "MISSION JEŠTĚD je 24hodinový firemní teambuilding kombinující týmovou outdoorovou misi, ubytování a soukromou party ve Warehouse Liberec.",
        trust: ["20–50 lidí", "Ještěd", "ubytování", "soukromý klub", "vše od jednoho dodavatele"],
        primary: { label: "Chci připravit misi pro náš tým", href: "/poptavka" },
        secondary: { label: "Zobrazit program", href: "/jak-to-funguje" },
        price: "od 4 990 Kč / osoba",
        img: "heroArrival",
        big: true,
      },
      {
        t: "facts",
        items: [
          ["Lokalita", "Liberec + Ještěd"],
          ["Délka", "4–6 hodin nebo 24 hodin"],
          ["Cena", "od 2 490 Kč / osoba"],
          ["Skupina", "20–50 lidí (až 100)"],
          ["Doprava", "door-to-door autobus možný"],
          ["Počasí", "weather plan v ceně"],
        ],
      },
      {
        t: "section",
        kicker: "O CO JDE",
        heading: "Nepřijedete na další teambuilding. Přijedete splnit misi.",
        paras: [
          "Vaši zaměstnanci předem neznají trasu. Nevědí, jaké úkoly je čekají. Nevědí, který tým vyhraje. Vědí pouze jedno: bez svého týmu se do cíle nedostanou.",
          "Mapa. Čas. Rozhodnutí. Ještěd. A večer Warehouse — soukromý klub jen pro vaši firmu.",
          "Extreme Teambuilding je projekt společnosti Warehouse club Liberec s.r.o. zaměřený na kompletně organizované firemní teambuildingy a offsite akce v Liberci a oblasti Ještědu pro týmy 20–50 lidí. Mission Ještěd kombinuje outdoorovou misi, dopravu v místě, ubytování, stravování a privátní party — jednu poptávku, jednoho koordinátora, jednu fakturu.",
        ],
        img: "envelope",
      },
      {
        t: "steps",
        kicker: "JAK TO FUNGUJE",
        heading: "Pět fází. Jedna mise.",
        items: [
          { k: "01", t: "ARRIVAL", d: "Příjezd do Warehouse Liberec. Check-in, občerstvení, první instrukce." },
          { k: "02", t: "THE DROP", d: "Organizovaný transport na start. Mission Pack, mapa, odpočet běží." },
          { k: "03", t: "THE MISSION", d: "Orientace, checkpointy a týmové úkoly směrem k Ještědu." },
          { k: "04", t: "THE SUMMIT", d: "Finish pod vysílačem. Týmová fotografie a finish drink." },
          { k: "05", t: "WAREHOUSE", d: "Večeře, vyhlášení výsledků a soukromá party do 02:00." },
        ],
      },
      { t: "gallery", kicker: "VISUAL STORY", heading: "Takhle vypadá mise", story: true },
      { t: "supplier" },
      { t: "packages" },
      { t: "audience" },
      {
        t: "section",
        kicker: "FLAGSHIP",
        heading: "MISSION JEŠTĚD",
        paras: [
          "24hodinová firemní mise: arrival ve Warehouse, briefing, drop na start, checkpointy v Ještědském hřbetu, finish na Ještědu, večeře, vyhlášení a soukromá party.",
          "Vaši lidé znají termín. My známe zbytek.",
        ],
        img: "summit",
        link: { label: "Zobrazit Mission Ještěd", href: "/mission-jested" },
      },
      {
        t: "section",
        kicker: "WAREHOUSE AFTER MISSION",
        heading: "Po misi nekončíte. Warehouse teprve začíná.",
        paras: [
          "Celý industriální klub jen pro vaši firmu. DJ, bar, promítání fotografií z mise a party do dvou ráno. Nikdo cizí, žádné kompromisy.",
        ],
        img: "warehouseParty",
        reverse: true,
        link: { label: "Víc o Warehouse party", href: "/warehouse-party" },
      },
      { t: "safety" },
      { t: "casestudies" },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: "Pro kolik lidí je Mission Ještěd?", a: "Standardně pro týmy 20–50 lidí. Umíme i menší skupiny (minimální cena akce Mission 24 je 129 000 Kč) i formáty do 100 lidí." },
          { q: "Musí být účastníci sportovci?", a: "Ne. Obtížnost mise má úrovně a program přizpůsobíme kondici týmu. Fyzickou část lze u jednotlivců vynechat." },
          { q: "Co když bude pršet?", a: "Mise má weather plan: varianty trasy, kryté checkpointy a indoor backup ve Warehouse. Akce se neruší — přizpůsobí se." },
          { q: "Je možné zajistit autobus z Prahy?", a: "Ano. Vyzvedneme váš tým před kanceláří a zase ho tam vrátíme. Dopravu nabídneme v rámci kalkulace." },
          { q: "Co je v ceně?", a: "Mission 24 zahrnuje misi, 1 noc, dopravu v místě, lunch/snack, finish drink, večeři, soukromý Warehouse s DJ, fotografa a snídani." },
        ],
      },
      { t: "leadform", heading: "PŘIPRAVÍME VÁM MISI", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program 24hodinové mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/teambuilding-praha", title: "Teambuilding Praha", text: "Pro firmy z Prahy včetně dopravy." },
      { href: "/jak-to-funguje", title: "Jak to funguje", text: "Pět fází mise krok za krokem." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
    ],
  },

  missionJested: {
    path: "/mission-jested",
    type: "mission",
    seo: {
      title: "Mission Ještěd | 24hodinová firemní mise na Ještěd",
      description: "Mission Ještěd: briefing, drop, checkpointy v Ještědském hřbetu, finish na Ještědu, večeře a soukromá Warehouse party. Program, scoring a cena.",
      schema: ["Service", "BreadcrumbList"],
    },
    h1: "MISSION JEŠTĚD",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Mission Ještěd", href: "/mission-jested" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "FLAGSHIP EXPERIENCE",
        title: "MISSION JEŠTĚD",
        sub: "24 hodin, které ukážou, jak váš tým opravdu funguje. Outdoorová mise, ubytování a soukromá Warehouse party — vše od jednoho dodavatele.",
        trust: ["20–50 lidí", "Ještěd", "ubytování", "soukromý klub"],
        primary: { label: "Chci připravit misi pro náš tým", href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        price: "od 4 990 Kč / osoba",
        img: "summit",
        big: true,
      },
      {
        t: "answer",
        q: "Co je Mission Ještěd?",
        short: "Mission Ještěd je vlajkový 24hodinový firemní teambuilding Extreme Teambuilding: řízená outdoorová týmová mise v Ještědském hřbetu s checkpointy a finishi na Ještědu, ubytováním, večeří a soukromou večerní party ve Warehouse Liberec.",
        paras: [
          "Účastníci předem neznají trasu ani úkoly. Celý program od arrival po check-out organizuje jeden dodavatel — Warehouse club Liberec s.r.o.",
          "Skóre netvoří jen rychlost: 30 % čas, 40 % splněné úkoly, 20 % týmová spolupráce a 10 % bonusové challenge. Nejrychlejší jednotlivec nevyhrává — vyhrává tým, který funguje společně.",
        ],
      },
      {
        t: "facts",
        items: [
          ["Lokalita", "Warehouse Liberec + Ještědský hřbet"],
          ["Délka", "24 hodin (Mission 24)"],
          ["Cena", "od 4 990 Kč / osoba, min. 129 000 Kč"],
          ["Skupina", "20–50 lidí"],
          ["Obtížnost", "úrovně dle kondice týmu"],
          ["Jazyk", "česky nebo anglicky"],
        ],
      },
      { t: "timeline" },
      { t: "game" },
      {
        t: "gallery",
        kicker: "Z MISE",
        heading: "Obálka. Mapa. Les. Checkpoint. Ještěd. Finish. Warehouse.",
      },
      {
        t: "section",
        kicker: "KDO VYHRÁVÁ",
        heading: "Nejrychlejší jednotlivec nevyhrává. Vyhrává tým, který funguje společně.",
        paras: [
          "Mise končí, až když je v cíli celý tým. Skóre tvoří čas jen ze 30 % — zbytek tvoří kvalita splněných úkolů, spolupráce hodnocená instruktory a bonusové výzvy.",
          "Vaši lidé znají termín. My známe zbytek.",
        ],
        img: "finishDrink",
      },
      { t: "packages" },
      { t: "upsells" },
      {
        t: "faq",
        heading: "Časté otázky k Mission Ještěd",
        items: [
          { q: "Jak dlouho trvá Mission Ještěd?", a: "Outdoorová část 13:30–17:00. Kompletní program Mission 24 od arrival v 11:00 první den do check-outu v 11:00 druhý den. Existuje i jednodenní varianta 4–6 hodin." },
          { q: "Dozví se účastníci program předem?", a: "Ne — a o to jde. Účastníci znají termín, doporučené oblečení a místo srazu. Koordinátor z firmy ví vše předem." },
          { q: "Kde mise probíhá?", a: "Start a základna jsou ve Warehouse Liberec (Hanychovská 10). Mise vede Ještědským hřbetem s finishi na Ještědu. Přesná trasa se účastníkům neprozrazuje." },
          { q: "Je mise vhodná i pro nesportovce?", a: "Ano. Obtížnost má úrovně, tempo drží tým a fyzické části lze u jednotlivců vynechat. Rozhoduje spolupráce, ne kondice." },
        ],
      },
      { t: "leadform", heading: "PŘIPRAVÍME VÁM MISI", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/jak-to-funguje", title: "Jak to funguje", text: "Pět fází mise krok za krokem." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub po misi." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
      { href: "/ubytovani", title: "Ubytování", text: "Kde tým přenocuje." },
    ],
  },

  firemniTeambuilding: {
    path: "/firemni-teambuilding",
    type: "core",
    seo: {
      title: "Firemní teambuilding | Mission Ještěd & Warehouse Liberec",
      description: "Firemní teambuilding, který firmy probírají měsíce potom: řízená mise na Ještěd, ubytování a soukromá Warehouse party. Pro týmy 20–50 lidí.",
      schema: ["Service", "BreadcrumbList"],
    },
    h1: "Firemní teambuilding, který není další povinná akce",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Firemní teambuilding", href: "/firemni-teambuilding" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "FIREMNÍ TEAMBUILDING",
        title: "Firemní teambuilding, který není další povinná akce",
        sub: "Mission Ještěd kombinuje řízenou outdoorovou misi, ubytování a soukromou party ve Warehouse Liberec. Firma řeší jednoho dodavatele — my.",
        trust: ["20–50 lidí", "Ještěd", "ubytování", "soukromý klub", "jeden dodavatel"],
        primary: { label: "Chci připravit misi pro náš tým", href: "/poptavka" },
        secondary: { label: "Zobrazit program", href: "/jak-to-funguje" },
        price: "od 4 990 Kč / osoba",
        img: "forestMission",
      },
      {
        t: "facts",
        items: [
          ["Pro koho", "firmy 20–50 lidí"],
          ["Lokalita", "Liberec + Ještěd"],
          ["Délka", "4–6 hodin / 24 hodin / víkend"],
          ["Cena", "od 2 490 Kč / osoba"],
          ["Doprava", "door-to-door autobus možný"],
          ["Dodavatel", "Warehouse club Liberec s.r.o."],
        ],
      },
      {
        t: "answer",
        q: "Co je firemní teambuilding Extreme Teambuilding?",
        short: "Kompletní řízená týmová mise s příběhem, checkpointy a soukromou večerní party v Liberci pod Ještědem. Účastníci předem neznají průběh — a firma neřeší nic než termín.",
        paras: [
          "Neprodáváme výšlap na Ještěd ani obyčejný firemní večírek. Prodáváme 24 hodin, během kterých váš tým projde misí, oslaví finish a stráví noc v soukromém klubu.",
          "Extrémní je zážitek, ne riziko. Program má úrovně obtížnosti, weather plan a bezpečnostní protokol.",
        ],
      },
      {
        t: "section",
        kicker: "PROČ TO FUNGUJE",
        heading: "Teambuilding, kde lidé nehrají tým — jsou tým",
        paras: [
          "Checkpointy jsou navržené tak, aby je jednotlivec nezvládl. Komunikace, leadership, důvěra a rozhodování pod tlakem nejsou workshopy — jsou podmínka finishi.",
          "Večer ve Warehouse pak není formální závěr, ale oslava. A právě tam se rodí historky, které firma vypráví další rok.",
        ],
        img: "warehouseParty",
      },
      { t: "packages" },
      { t: "audience" },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: "Jaký je rozdíl oproti eventové agentuře?", a: "Nejsme agentura, která skládá dodavatele. Warehouse je náš prostor, mise je náš produkt, instruktoři jsou naši. Jeden dodavatel, celá akce." },
          { q: "Jak daleko předem máme poptat?", a: "Podzimní a vánoční termíny doporučujeme 6–8 týdnů předem, mimo sezónu stačí 3–4 týdny." },
          { q: "Dokážete přizpůsobit program firmě?", a: "Ano. Od custom company storyline přes brandovaná trička po vlastní vyhlášení večer. Napište nám představu." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mise, nocleh a party v jednom." },
    ],
  },

  ubytovaniTeambuilding: {
    path: "/teambuilding-s-ubytovanim",
    type: "core",
    seo: {
      title: "Teambuilding s ubytováním | Mission 24 na Ještědu",
      description: "Firemní teambuilding s ubytováním: Mission Ještěd, nocleh pro celý tým, večeře, soukromá Warehouse party a snídaně. Od 4 990 Kč na osobu.",
      schema: ["Service", "BreadcrumbList"],
    },
    h1: "Teambuilding s ubytováním: mise, nocleh a party v jednom",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Teambuilding s ubytováním", href: "/teambuilding-s-ubytovanim" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "TEAMBULDING S UBYTOVÁNÍM",
        title: "Teambuilding s ubytováním: mise, nocleh a party v jednom",
        sub: "Mission 24 spojuje odpolední misi na Ještěd, večeři, soukromou Warehouse party, nocleh a snídani. Tým je pohromadě celých 24 hodin.",
        trust: ["20–50 lidí", "1 noc", "soukromý klub", "snídaně v ceně"],
        primary: { label: "Chci teambuilding s ubytováním", href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        price: "od 4 990 Kč / osoba",
        img: "dinner",
      },
      {
        t: "facts",
        items: [
          ["Nocleh", "v ceně Mission 24 a Weekend"],
          ["Kapacita", "20–50+ lidí pohromadě"],
          ["Stravování", "večeře + snídaně v ceně"],
          ["Check-out", "11:00 po snídani"],
          ["Lokalita", "Liberec, u Ještědu"],
          ["Cena", "od 4 990 Kč / osoba"],
        ],
      },
      {
        t: "answer",
        q: "Proč teambuilding s ubytováním?",
        answer: undefined,
        short: "Protože tým se nespojí mezi 14. a 16. hodinou. Spojí se večer u společného stolu, u baru po misi a ráno u snídaně. Ubytování promění akci v zážitek.",
        paras: [
          "Mission 24 obsahuje 1 noc pro celý tým, večeři, soukromý Warehouse s DJ a snídani. Mission Weekend přidává druhou noc a druhý program.",
          "Ubytování řešíme v ověřené kapacitě v Liberci a okolí tak, aby byl tým pohromadě. Konkrétní variantu potvrdíme v nabídce podle termínu.",
        ],
      },
      {
        t: "section",
        kicker: "CO JE V CENĚ",
        heading: "Vše, co tým potřebuje na 24 hodin",
        list: [
          "Mission Ještěd — outdoorová týmová mise",
          "1 noc ubytování pro celý tým",
          "Lunch/snack, večeře a snídaně",
          "Finish drink na Ještědu",
          "Soukromý Warehouse s DJ a barem",
          "Fotograf po celou akci",
          "Doprava v místě akce",
        ],
        paras: ["Minimální cena akce je 129 000 Kč. Orientační příklady: 30 lidí 169 000 Kč, 40 lidí 209 000 Kč, 50 lidí 249 000 Kč."],
      },
      { t: "pricetable" },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: "Kde budeme ubytovaní?", a: "V ověřené kapacitě v Liberci a okolí Ještědu tak, aby byl tým pohromadě. Konkrétní objekt potvrdíme v nabídce podle termínu a velikosti skupiny." },
          { q: "Jsou v ceně všechna jídla?", a: "Mission 24 zahrnuje lunch/snack, večeři a snídani. Dietní omezení (vegetariáni, alergie) vyřešíme — uveďte je v poptávce." },
          { q: "Lze přidat druhou noc?", a: "Ano, jako upsell — nebo rovnou zvolte Mission Weekend se dvěma noclehy a druhým programem." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/ubytovani", title: "Ubytování", text: "Jak řešíme nocleh pro tým." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub jen pro vás." },
    ],
  },

  cenik: {
    path: "/cenik",
    type: "core",
    seo: {
      title: "Ceník firemního teambuildingu | Mission Ještěd od 4 990 Kč/os.",
      description: "Ceník Mission Ještěd: Mission od 2 490 Kč/os., Mission 24 od 4 990 Kč/os. (min. 129 000 Kč), Mission Weekend od 6 490 Kč/os. Příklady cen pro 20–50 lidí.",
      schema: ["Service", "BreadcrumbList"],
    },
    h1: "Ceník: tři balíčky, žádné hvězdičky pod čarou",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Ceník", href: "/cenik" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "CENÍK",
        title: "Ceník: tři balíčky, žádné hvězdičky pod čarou",
        sub: "Cena je jasná předem. Finální nabídka závisí jen na termínu a konfiguraci — ne na tom, kolikrát zavoláte.",
        primary: { label: "Chci nezávaznou kalkulaci", href: "/poptavka" },
        secondary: { label: "Zobrazit program", href: "/jak-to-funguje" },
        img: "mapTable",
      },
      {
        t: "facts",
        items: [
          ["Balíčky", "Mission / Mission 24 / Mission Weekend"],
          ["Cena od", "2 490 Kč / osoba"],
          ["Minimální akce", "129 000 Kč (Mission 24)"],
          ["Skupina", "10–100 lidí"],
          ["Fakturace", "Warehouse club Liberec s.r.o."],
          ["Termíny", "celoročně, všední dny i víkendy"],
        ],
      },
      { t: "packages" },
      { t: "pricetable" },
      { t: "upsells" },
      {
        t: "section",
        kicker: "JAK ČÍST CENY",
        heading: "Orientačně znamená orientačně",
        paras: [
          "Uvedené ceny jsou reálné příklady, ne marketingové lákadlo od. Finální nabídka se odvíjí od termínu (sezóna, všední den/víkend), počtu účastníků a konfigurace programu.",
          "V každé nabídce dostanete kompletní rozpis — co je v ceně, co je upsell a kolik stojí doprava. Bez překvapení na faktuře.",
        ],
      },
      {
        t: "faq",
        heading: "Časté otázky k cenám",
        items: [
          { q: "Jaká je minimální cena akce?", a: "Mission 24 má minimální cenu akce 129 000 Kč (odpovídá 20 lidem). Menší skupiny jsou možné za stejnou minimální cenu." },
          { q: "Fakturujete jako klasická firma?", a: "Ano. Provozovatelem je Warehouse club Liberec s.r.o., IČO 19829451, DIČ CZ19829451. Standardní smlouva a fakturace." },
          { q: "Co v ceně není?", a: "Doprava z vašeho města (umíme zajistit autobus door-to-door), open bar a prémiové upselly. Vše rozepíšeme v nabídce." },
          { q: "Jaké jsou storno podmínky?", a: "Storno podmínky jsou součástí nabídky a obchodních podmínek. Termín umíme v rozumném předstihu přesunout." },
        ],
      },
      { t: "leadform", heading: "CHCI NÁVRH MISE S CENOU", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/pruvodce/kolik-stoji-teambuilding", title: "Kolik stojí teambuilding", text: "Detailní rozbor cen." },
      { href: "/teambuilding-pro-30-lidi", title: "Teambuilding pro 30 lidí", text: "Logistika a rozpočet pro 30 lidí." },
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá." },
    ],
  },

  proFirmy: {
    path: "/pro-firmy",
    type: "core",
    seo: {
      title: "Pro firmy | Extreme Teambuilding by Warehouse Liberec",
      description: "Firemní teambuilding pro HR, office manažery a vedení: jeden dodavatel, transparentní cena, fakturace a program, který sedí týmům 20–100 lidí.",
      schema: ["BreadcrumbList"],
    },
    h1: "Pro firmy: jeden dodavatel, nula starostí",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Pro firmy", href: "/pro-firmy" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "PRO HR, OFFICE MANAŽERY A VEDENÍ",
        title: "Přijeďte. O zbytek se postaráme.",
        sub: "Jedna poptávka, jedna nabídka, jedna smlouva. Mise, doprava, jídlo, ubytování i party pod jedním dodavatelem — Warehouse club Liberec s.r.o.",
        primary: { label: "Chci připravit misi pro náš tým", href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        img: "warehouseExterior",
      },
      { t: "supplier" },
      { t: "audience" },
      {
        t: "section",
        kicker: "B2B PROCES",
        heading: "Jak probíhá spolupráce",
        paras: [
          "1) Poptávka — stačí počet lidí, termín a rozpočet. 2) Nezávazný návrh mise s cenou do několika pracovních dnů. 3) Smlouva a fakturace na Warehouse club Liberec s.r.o. 4) Před akcí checklist pro účastníky a koordinační schůzka. 5) Akce — na místě vás provede koordinátor. 6) Fotografie a vyhodnocení.",
          "Žádné překvapení na faktuře, žádné skryté poplatky. Cena, kterou schválíte, je cena, kterou zaplatíte.",
        ],
      },
      {
        t: "faq",
        heading: "Otázky, které nám firmy kladou",
        items: [
          { q: "Kdo je provozovatel?", a: "Warehouse club Liberec s.r.o., Hanychovská 328/10, 460 07 Liberec, IČO 19829451, DIČ CZ19829451. Warehouse Liberec je náš vlastní klub — proto držíme celý řetězec akce v jedné ruce." },
          { q: "Umíte připravit dokumentaci pro interní schválení?", a: "Ano. Návrh mise obsahuje program, rozpis ceny a bezpečnostní rámec — vše, co HR potřebuje pro schválení vedením." },
          { q: "Jaké skupiny zvládnete?", a: "Standardně 20–50 lidí, po individuální domluvě 10–100. Pro každou velikost máme připravenou logistiku a rozdělení do týmů." },
          { q: "Dáte referenční kontakt?", a: "Reálné reference zveřejňujeme v případových studiích — pouze se souhlasem klienta, jmenovitě nebo anonymizovaně." },
        ],
      },
      { t: "leadform", heading: "PŘIPRAVÍME VÁM MISI", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/o-nas", title: "O nás", text: "Kdo za projektem stojí." },
      { href: "/pripadove-studie", title: "Případové studie", text: "Reálné akce, reálné firmy." },
    ],
  },

  jakToFunguje: {
    path: "/jak-to-funguje",
    type: "core",
    seo: {
      title: "Jak funguje Mission Ještěd | Program krok za krokem",
      description: "Program Mission Ještěd krok za krokem: arrival, briefing, the drop, mise s checkpointy, summit, večeře, vyhlášení a Warehouse party. Kompletní časová osa.",
      schema: ["BreadcrumbList"],
    },
    h1: "Jak to funguje: pět fází, jedna mise",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Jak to funguje", href: "/jak-to-funguje" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "JAK TO FUNGUJE",
        title: "Vaši lidé znají termín. My známe zbytek.",
        sub: "Celý program držíme pod kontrolou od prvního arrival po poslední snídani. Tady je kompletní časová osa Mission Ještěd.",
        primary: { label: "Chci připravit misi pro náš tým", href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        img: "envelope",
      },
      { t: "timeline" },
      { t: "game" },
      {
        t: "section",
        kicker: "PRO HR",
        heading: "Co firma ví předem — a co lidé ne",
        paras: [
          "Koordinátor z vaší firmy dostane před akcí kompletní harmonogram, kontakty a bezpečnostní rámec. Účastníci dostanou termín, místo srazu a doporučené oblečení.",
          "Utajení není podmínka, ale nástroj. Pokud někdo překvapení nechce, koordinátor mu program sdělí — mise funguje i tak.",
        ],
        img: "mapTable",
      },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: "Jak dlouho trvá celá akce?", a: "Mission 24: arrival 11:00 první den, check-out 11:00 druhý den. Jednodenní Mission: 4–6 hodin. Mission Weekend: 2 noci." },
          { q: "Kdo doprovází týmy na trati?", a: "Instruktoři jsou na checkpointech a nouzový kontakt má každý tým. Trasa vede značeným terénem Ještědského hřbetu." },
          { q: "Můžeme program posunout?", a: "Ano. Časy jednotlivých fází umíme přizpůsobit vaší dopravě nebo internímu programu — harmonogram sladíme před akcí." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mise, nocleh a party v jednom." },
    ],
  },

  bezpecnost: {
    path: "/bezpecnost",
    type: "core",
    seo: {
      title: "Bezpečnost | Extreme Experience. Safe Execution.",
      description: "Bezpečnost na Mission Ještěd: úrovně obtížnosti, weather plan, nouzový kontakt, možnost fyzickou část vynechat. Extrémní je zážitek, ne riziko.",
      schema: ["BreadcrumbList"],
    },
    h1: "EXTREME EXPERIENCE. SAFE EXECUTION.",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Bezpečnost", href: "/bezpecnost" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "BEZPEČNOST",
        title: "Extrémní je zážitek, ne riziko.",
        sub: "Mission Ještěd vytváří napětí příběhem a časovým limitem — ne nebezpečím. Bezpečnostní protokol je neměnný v každém počasí a pro každý tým.",
        primary: { label: "Chci připravit misi pro náš tým", href: "/poptavka" },
        secondary: { label: "Zobrazit program", href: "/jak-to-funguje" },
        img: "forestMission",
      },
      { t: "safety" },
      {
        t: "section",
        kicker: "WEATHER PLAN",
        heading: "Co se stane, když prší",
        paras: [
          "Předpověď sledujeme 5 dní před akcí a finální konfiguraci trasy potvrzujeme 24–48 hodin před startem. Rozhoduje bezpečnost, ne dramaturgie.",
          "Varianty: plná trasa, kratší trasa s krytými checkpointy, indoor+outdoor mix a v krajním případě indoor backup přímo ve Warehouse. Akce se neruší — přizpůsobí se.",
        ],
        img: "qrCheckpoint",
      },
      {
        t: "faq",
        heading: "Otázky k bezpečnosti",
        items: [
          { q: "Je mise vhodná i pro nesportovní kolegy?", a: "Ano. Obtížnost má úrovně a program se přizpůsobí kondici týmu. Fyzickou část lze u jednotlivců vynechat — čekají je role na checkpointech i večerní program." },
          { q: "Co když se někdo zraní?", a: "Každý tým má nouzový kontakt, instruktoři jsou na checkpointech a trasa vede značeným terénem s možností rychlého sestupu. Žádné improvizované nebezpečné překážky." },
          { q: "Jaké je maximální riziko na trati?", a: "Srovnatelné s organizovanou turistickou túrou. Mise neobsahuje lezení, skoky ani adrenalinové prvky — adrenalin vzniká z časového tlaku a rozhodování." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/pruvodce/teambuilding-kdyz-prsi", title: "Teambuilding, když prší", text: "Jak funguje weather plan." },
      { href: "/jak-to-funguje", title: "Jak to funguje", text: "Program krok za krokem." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/outdoor-teambuilding", title: "Outdoor teambuilding", text: "Mise v přírodě." },
    ],
  },

  warehouseParty: {
    path: "/warehouse-party",
    type: "core",
    seo: {
      title: "Warehouse Party | Soukromý klub pro vaši firmu v Liberci",
      description: "Warehouse Liberec: soukromý industriální klub jen pro vaši firmu. DJ, bar, promítání fotografií z mise a party do 02:00. Součást Mission 24.",
      schema: ["Service", "BreadcrumbList"],
    },
    h1: "Po misi nekončíte. Warehouse teprve začíná.",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Warehouse party", href: "/warehouse-party" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "WAREHOUSE AFTER MISSION",
        title: "Celý klub. Jen pro vás. Do dvou ráno.",
        sub: "Industriální Warehouse Liberec se na váš večer zavře veřejnosti. DJ, bar, promítání fotografií z mise — a nikdo cizí.",
        primary: { label: "Chci Warehouse pro naši firmu", href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        img: "warehouseParty",
        big: true,
      },
      {
        t: "section",
        kicker: "VEČER",
        heading: "Jak vypadá večer ve Warehouse",
        paras: [
          "19:30 večeře u dlouhého stolu. 21:00 vyhlášení výsledků mise, ceny a promítání fotografií — moment, kdy se večer rozjede. 21:30–02:00 DJ, bar a party.",
          "Warehouse je náš vlastní prostor. Bar, světla, ozvučení a kapacita pro 20–100 lidí — vše ladíme podle vaší firmy.",
        ],
        img: "dinner",
      },
      {
        t: "section",
        kicker: "UPGRADY",
        heading: "Večer na míru",
        list: [
          "Open bar — celovečerní otevřený bar",
          "Premium catering a živá stanoviště",
          "Live band místo nebo po DJ setu",
          "Moderátor a vlastní firemní vyhlášení",
          "Brandovaná trička, medaile a trofeje",
        ],
        paras: ["Party je součástí balíčků Mission 24 a Mission Weekend. K jednodenní misi ji lze přidat jako rozšíření."],
        img: "warehouseExterior",
        reverse: true,
      },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: "Je Warehouse opravdu soukromý?", a: "Ano. Na večer vaší akce je klub uzavřen pro veřejnost — včetně baru a DJ. Vaše firma je jediný host." },
          { q: "Jaká je kapacita Warehouse?", a: "Komfortně 20–100 lidí podle konfigurace večera. Přesnou kapacitu potvrdíme v nabídce." },
          { q: "Dá se Warehouse pronajmout samostatně?", a: "Primárně je součástí misí. Samostatný pronájem pro firemní akce řešíme individuálně — napište nám." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi i večer", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/teambuilding-s-party", title: "Teambuilding s party", text: "Mise + soukromý klub." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/ubytovani", title: "Ubytování", text: "Kde tým přenocuje." },
    ],
  },

  ubytovani: {
    path: "/ubytovani",
    type: "core",
    seo: {
      title: "Ubytování pro firemní tým | Mission Ještěd Liberec",
      description: "Ubytování v rámci Mission 24 a Mission Weekend: nocleh pro celý tým 20–50 lidí v Liberci u Ještědu, snídaně, check-out po misi. Vše v jednom balíčku.",
      schema: ["BreadcrumbList"],
    },
    h1: "Ubytování: celý tým pod jednou střechou (a ráno společná snídaně)",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Ubytování", href: "/ubytovani" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "UBYTOVÁNÍ",
        title: "Nocleh, který drží tým pohromadě",
        sub: "Ubytování pro 20–50 lidí řešíme v ověřené kapacitě v Liberci a okolí Ještědu. Po party nikdo nedojíždí, ráno je snídaně pro všechny.",
        primary: { label: "Chci teambuilding s ubytováním", href: "/poptavka" },
        secondary: { label: "Zobrazit ceník", href: "/cenik" },
        img: "dinner",
      },
      {
        t: "answer",
        q: "Jak řešíte ubytování pro firemní tým?",
        short: "Ubytování je součást balíčků Mission 24 (1 noc) a Mission Weekend (2 noci). Kapacitu pro celý tým držíme v ověřených objektech v Liberci a okolí — konkrétní variantu potvrdíme v nabídce podle termínu.",
        paras: [
          "Po večerní party ve Warehouse nikdo neřeší taxi ani odvoz. Sprchy a převlečení po misi jsou samozřejmostí, check-out je po snídani v 11:00.",
        ],
      },
      {
        t: "section",
        kicker: "HARMONOGRAM RÁNA",
        heading: "Ráno po misi",
        paras: [
          "Snídaně 8:30–10:00, check-out v 11:00. Pro firmy s dopravou od nás čeká autobus po check-outu — tým vystoupí před vlastní kanceláří kolem oběda.",
          "U Mission Weekend následuje po snídani druhý program — od workshopu po druhou outdoorovou výzvu.",
        ],
        img: "warehouseExterior",
      },
      {
        t: "faq",
        heading: "Časté otázky",
        items: [
          { q: "Kde přesně budeme bydlet?", a: "Konkrétní objekt potvrzujeme v nabídce podle termínu a velikosti skupiny. Vždy jde o ověřenou kapacitu tak, aby byl tým pohromadě." },
          { q: "Jsou v ceně snídaně?", a: "Ano. Mission 24 obsahuje snídani, Mission Weekend dvě snídaně." },
          { q: "Lze přidat druhou noc?", a: "Ano, jako upsell — nebo rovnou zvolte Mission Weekend." },
        ],
      },
      { t: "cta", heading: "Připravíme vám misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Mise, nocleh a party v jednom." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub po misi." },
    ],
  },

  oNas: {
    path: "/o-nas",
    type: "core",
    seo: {
      title: "O nás | Extreme Teambuilding by Warehouse Liberec",
      description: "Kdo stojí za Extreme Teambuilding: Warehouse club Liberec s.r.o., provozovatel klubu Warehouse Liberec. Mise na Ještěd od lidí, kteří terén znají.",
      schema: ["Organization", "BreadcrumbList"],
    },
    h1: "Kdo za tím stojí",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "O nás", href: "/o-nas" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "O NÁS",
        title: "Extreme Teambuilding by Warehouse Liberec",
        sub: "Nejsme eventová agentura. Jsme lidé z Warehouse Liberec — industriálního klubu, který provozujeme, a Ještěd je náš dvorek.",
        img: "warehouseExterior",
      },
      {
        t: "section",
        kicker: "PROVOZOVATEL",
        heading: "Warehouse club Liberec s.r.o.",
        paras: [
          "Provozovatelem projektu Extreme Teambuilding je Warehouse club Liberec s.r.o., Hanychovská 328/10, 460 07 Liberec, IČO 19829451, DIČ CZ19829451.",
          "Warehouse Liberec je náš vlastní industriální klub. Proto umíme nabídnout něco, co agentury nemůžou: soukromé venue, bar, DJ a zázemí v jedné ruce — bez prostředníků a bez koordinačního rizika.",
        ],
      },
      {
        t: "section",
        kicker: "PROČ MISSION JEŠTĚD",
        heading: "Mise, kterou jsme chtěli sami zažít",
        paras: [
          "Mission Ještěd vznikla z jednoduché frustrace: firemní teambuildingy bývají buď nudné, nebo dětinské. Chtěli jsme zážitek, který respektuje dospělé lidi — příběh, nejistota, skutečná hora a večer, který stojí za to.",
          "Extrémní je zážitek, ne riziko. To je princip, na kterém stavíme každou misi.",
        ],
        img: "summit",
        reverse: true,
      },
      { t: "cta", heading: "Poznejte nás na misi", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/kontakt", title: "Kontakt", text: "Adresa, IČO a kontaktní formulář." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
    ],
  },

  kontakt: {
    path: "/kontakt",
    type: "core",
    seo: {
      title: "Kontakt | Extreme Teambuilding by Warehouse Liberec",
      description: "Kontakt na Extreme Teambuilding: Warehouse club Liberec s.r.o., Hanychovská 328/10, Liberec. Napište nám — návrh mise je nezávazný.",
      schema: ["Organization", "BreadcrumbList"],
    },
    h1: "Kontakt",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Kontakt", href: "/kontakt" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "KONTAKT",
        title: "Připravíme vám misi. Začněte poptávkou.",
        sub: "Nejrychlejší cesta je poptávkový formulář — stačí počet lidí, termín a rozpočet. Odpovídáme s návrhem mise a cenou.",
        primary: { label: "Přejít na poptávku", href: "/poptavka" },
        img: "mapTable",
      },
      { t: "contactinfo" },
      { t: "leadform", heading: "PŘIPRAVÍME VÁM MISI", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/poptavka", title: "Poptávka", text: "Nezávazný návrh mise." },
      { href: "/o-nas", title: "O nás", text: "Kdo za projektem stojí." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  },

  pripadoveStudie: {
    path: "/pripadove-studie",
    type: "casestudies",
    seo: {
      title: "Případové studie | Extreme Teambuilding",
      description: "Reálné firemní akce Mission Ještěd: počty účastníků, programy, výsledky a zpětná vazba klientů. Publikujeme pouze se souhlasem klienta.",
      schema: ["BreadcrumbList"],
    },
    h1: "Případové studie: reálné akce, reálné firmy",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Případové studie", href: "/pripadove-studie" },
    ],
    blocks: [
      {
        t: "hero",
        overline: "REFERENCE",
        title: "Reálné akce. Reálné firmy. Žádné vymyšlené loga.",
        sub: "Případové studie publikujeme pouze z reálných akcí — jmenovitě se souhlasem klienta, nebo anonymizovaně (např. „pražská technologická firma, 42 účastníků“).",
        img: "summit",
      },
      { t: "casestudies" },
      {
        t: "section",
        kicker: "CO BUDEME PUBLIKOVAT",
        heading: "Jak bude vypadat každá případová studie",
        list: [
          "Firma a logo (nebo anonymizace)",
          "Počet účastníků a město, odkud přijeli",
          "Zvolený balíček a program akce",
          "Průběh mise a počasí",
          "Fotogalerie z akce",
          "Citace klienta a výsledek",
        ],
        paras: ["Žádné falešné reference, žádná vymyšlená hodnocení. Dokud nemáme reálnou akci, kterou můžeme ukázat, ukazujeme tohle."],
      },
      { t: "cta", heading: "Buďte naší první případovou studií", text: "Stačí počet lidí, termín a rozpočet. Návrh mise je nezávazný." },
    ],
    related: [
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/teambuilding-praha", title: "Teambuilding Praha", text: "Pro firmy z Prahy." },
    ],
  },

  obchodniPodminky: {
    path: "/obchodni-podminky",
    type: "legal",
    seo: {
      title: "Obchodní podmínky | Extreme Teambuilding",
      description: "Obchodní podmínky poskytování služeb Extreme Teambuilding — Warehouse club Liberec s.r.o., IČO 19829451.",
      schema: ["BreadcrumbList"],
    },
    h1: "Obchodní podmínky",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Obchodní podmínky", href: "/obchodni-podminky" },
    ],
    blocks: [
      {
        t: "prose",
        sections: [
          { heading: "1. Provozovatel", paras: ["Poskytovatelem služeb je Warehouse club Liberec s.r.o., se sídlem Hanychovská 328/10, 460 07 Liberec, IČO 19829451, DIČ CZ19829451 (dále jen „poskytovatel“)."] },
          { heading: "2. Předmět", paras: ["Poskytovatel zajišťuje organizaci firemních teambuildingových akcí (dále jen „akce“) včetně doprovodných služeb — dopravy, stravování, ubytování a večerních programů. Konkrétní rozsah vždy vymezuje individuální nabídka."] },
          { heading: "3. Objednání a smlouva", paras: ["Poptávka přes web je nezávazná. Závazná objednávka vzniká akceptací písemné nabídky (e-mailem) nebo podpisem smlouvy. Součástí nabídky je program, cena a platební podmínky."] },
          { heading: "4. Ceny a platba", paras: ["Ceny uvedené na webu jsou orientační. Závazná je cena v individuální nabídce. Fakturace probíhá dle podmínek nabídky, standardně záloha před akcí a doplatek po akci."] },
          { heading: "5. Storno", paras: ["Storno podmínky jsou součástí individuální nabídky. Poskytovatel umožňuje v rozumném předstihu jednorázový přesun termínu dle aktuální kapacity."] },
          { heading: "6. Počasí a bezpečnost", paras: ["Akce mají weather plan — v případě nepříznivého počasí se program přizpůsobí (varianta trasy nebo indoor backup), akce se zásadně neruší. Poskytovatel je oprávněn upravit program z důvodu bezpečnosti účastníků."] },
          { heading: "7. Odpovědnost", paras: ["Účastníci se řídí pokyny instruktorů. Poskytovatel neodpovídá za škody vzniklé porušením pokynů nebo bezpečnostního rámce akce."] },
        ],
      },
      { t: "cta", heading: "Máte dotaz k podmínkám?", text: "Napište nám přes poptávkový formulář nebo e-mail." },
    ],
    related: [
      { href: "/ochrana-osobnich-udaju", title: "Ochrana osobních údajů", text: "Jak zpracováváme data." },
      { href: "/kontakt", title: "Kontakt", text: "Adresa a kontakty." },
    ],
  },

  gdpr: {
    path: "/ochrana-osobnich-udaju",
    type: "legal",
    seo: {
      title: "Ochrana osobních údajů | Extreme Teambuilding",
      description: "Zásady zpracování osobních údajů (GDPR) — Warehouse club Liberec s.r.o. Jak nakládáme s údaji z poptávkových formulářů.",
      schema: ["BreadcrumbList"],
    },
    h1: "Ochrana osobních údajů",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Ochrana osobních údajů", href: "/ochrana-osobnich-udaju" },
    ],
    blocks: [
      {
        t: "prose",
        sections: [
          { heading: "1. Správce údajů", paras: ["Správcem osobních údajů je Warehouse club Liberec s.r.o., Hanychovská 328/10, 460 07 Liberec, IČO 19829451, DIČ CZ19829451."] },
          { heading: "2. Jaké údaje zpracováváme", paras: ["Údaje z poptávkových formulářů: jméno, firma, e-mail, telefon, počet účastníků, preferovaný termín, rozpočet a obsah zprávy. Dále technické údaje o návštěvě webu (cookies) v rozsahu dle vašeho souhlasu."] },
          { heading: "3. Účel zpracování", paras: ["Vyřízení poptávky, příprava nabídky, organizace akce a související komunikace. Údaje nepředáváme třetím stranám mimo dodavatele nezbytné pro realizaci akce (např. dopravce, ubytování)."] },
          { heading: "4. Doba uchování", paras: ["Údaje z nezrealizovaných poptávek uchováváme maximálně 2 roky. Údaje související se smlouvou po dobu stanovenou právními předpisy."] },
          { heading: "5. Vaše práva", paras: ["Máte právo na přístup k údajům, opravu, výmaz, omezení zpracování, přenositelnost a právo podat stížnost u ÚOOÚ. Pro uplatnění práv nás kontaktujte e-mailem."] },
        ],
      },
      { t: "cta", heading: "Dotaz k osobním údajům?", text: "Napište nám — odpovíme na každý dotaz." },
    ],
    related: [
      { href: "/cookies", title: "Cookies", text: "Jak používáme cookies." },
      { href: "/obchodni-podminky", title: "Obchodní podmínky", text: "Podmínky poskytování služeb." },
    ],
  },

  cookies: {
    path: "/cookies",
    type: "legal",
    seo: {
      title: "Cookies | Extreme Teambuilding",
      description: "Zásady používání cookies na webu ExtremeTeambuilding.cz — nezbytné, analytické a marketingové cookies a jak je spravovat.",
      schema: ["BreadcrumbList"],
    },
    h1: "Zásady používání cookies",
    breadcrumbs: [
      { label: "Úvod", href: "/" },
      { label: "Cookies", href: "/cookies" },
    ],
    blocks: [
      {
        t: "prose",
        sections: [
          { heading: "1. Co jsou cookies", paras: ["Cookies jsou malé textové soubory ukládané do vašeho zařízení při návštěvě webu. Používáme je k zajištění funkce webu a — s vaším souhlasem — k měření návštěvnosti a marketingu."] },
          { heading: "2. Nezbytné cookies", paras: ["Zajišťují základní funkce webu (např. uložení vašeho rozhodnutí o souhlasu). Nelze je vypnout."] },
          { heading: "3. Analytické cookies", paras: ["Používáme je k anonymnímu měření návštěvnosti a chování na webu. Spouštějí se pouze se souhlasem."] },
          { heading: "4. Marketingové cookies", paras: ["Používají se k měření konverzí z reklamních kampaní (např. Google Ads). Spouštějí se pouze se souhlasem."] },
          { heading: "5. Jak změnit souhlas", paras: ["Souhlas můžete kdykoliv změnit vymazáním cookies ve vašem prohlížeči — lišta se zobrazí znovu při další návštěvě."] },
        ],
      },
    ],
    related: [
      { href: "/ochrana-osobnich-udaju", title: "Ochrana osobních údajů", text: "Zásady GDPR." },
      { href: "/obchodni-podminky", title: "Obchodní podmínky", text: "Podmínky poskytování služeb." },
    ],
  },
};
